import { Row, Col, Divider } from "antd";
import RegisterForm from "../components/forms/RegisterForm";
import Link from "next/link";

import AuthLayout from "../components/layout/AuthLayout";
import * as colors from "../constants/colors";

const RegisterPage: React.FC = () => {
  return (
    <AuthLayout>
      <Row justify="center">
        <p className="text">Gratis account maken</p>
        <Col xs={24} sm={24} md={20} lg={20}>
          <RegisterForm />
        </Col>
      </Row>
      <Divider />
      <p className={`text-center`}>
        Heb je al een account ?{" "}
        <Link href="/login">
          <a style={{ color: colors.SECONDARY }}>Login hier</a>
        </Link>
      </p>
    </AuthLayout>
  );
};

export default RegisterPage;
